// extracted by mini-css-extract-plugin
module.exports = {"form":"algolia-autocomplete-input_form__c4uRv","label":"algolia-autocomplete-input_label__nM8fN","input":"algolia-autocomplete-input_input__hr6cO"};